<script>
  import { goto } from '$app/navigation';
  import DownloadReport from '$lib/components/DownloadReport.svelte';
  import { auth } from '$lib/stores/auth.svelte';

  if (auth.user?.role.includes('admin')) {
    goto('/admin/reports');
  } else if (auth.user?.role !== 'instructor') {
    goto('/');
  }
</script>

<DownloadReport />
